export enum EmailModalComponentLocators {
	fromField = 'formField',
	toField = 'toField',
	templateField = 'templateField',
	subjectField = 'subjectField',
	bodyField = 'bodyField',
	cancelButton = 'cancelButton',
	saveButton = 'saveButton',
}
